"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5651],{

/***/ 49377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Search_default; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24734);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31549);






var SvgSearch = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size && (outProps.width = size, outProps.height = size), color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_3__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "#786E64",
            d: "M9.5 16q-2.725 0-4.612-1.888T3 9.5t1.888-4.612Q6.778 3 9.5 3t4.613 1.888T16 9.5a6.1 6.1 0 0 1-1.3 3.8l5.6 5.6a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-5.6-5.6q-.75.6-1.725.95T9.5 16m0-2q1.875 0 3.188-1.312T14 9.5q0-1.876-1.312-3.187Q11.377 5.002 9.5 5T6.313 6.313 5 9.5t1.313 3.188T9.5 14"
        })
    }));
};
var Search_default = SvgSearch;



/***/ }),

/***/ 70256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ Dropdown; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@opendoor+tokens-studio@16.2.0/node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(64069);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.12_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/StyleSheet/index.js + 9 modules
var StyleSheet = __webpack_require__(97067);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.12_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/PixelRatio/index.js
var PixelRatio = __webpack_require__(56873);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/__generated__/icons/ChevronUp.js
var ChevronUp = __webpack_require__(19423);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/__generated__/icons/ChevronDown.js
var ChevronDown = __webpack_require__(25993);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/helpers/fontTokens.js
var fontTokens = __webpack_require__(48296);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/helpers/utils.js
var utils = __webpack_require__(15552);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/shared/TrackableContainer.js
var TrackableContainer = __webpack_require__(93243);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/inputs/shared/hooks.js
var hooks = __webpack_require__(95224);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/inputs/shared/InputError.js
var InputError = __webpack_require__(43802);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/inputs/shared/InputFrame.js
var InputFrame = __webpack_require__(12558);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/inputs/shared/InputLabel.js
var InputLabel = __webpack_require__(94301);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.12_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/View/index.js
var View = __webpack_require__(62262);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/inputs/Dropdown/PickerSelect.js






var getSelectedItem = function(param) {
    var items = param.items, key = param.key, value = param.value;
    var idx = items.findIndex(function(item) {
        return item.key && key ? item.key === key : item.value === value;
    });
    return idx === -1 && (idx = 0), items[idx] || {};
}, PickerSelect = function(param) {
    var disabled = param.disabled, style = param.style, pickerProps = param.pickerProps, Icon = param.Icon, items = param.items, placeholder = param.placeholder, itemKey = param.itemKey, value = param.value, onValueChange = param.onValueChange;
    var allItems = [
        placeholder
    ].concat(items), ref = (0,react.useState)(getSelectedItem({
        items: allItems,
        key: itemKey,
        value: value
    })), selectedItem = ref[0], setSelectedItem = ref[1], handleValueChange = function(value2) {
        var selectedItem2 = getSelectedItem({
            items: allItems,
            value: value2
        });
        setSelectedItem(selectedItem2), onValueChange(selectedItem2.value);
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(View/* default */.Z, {
        style: [
            {
                alignSelf: "stretch"
            },
            style === null || style === void 0 ? void 0 : style.viewContainer
        ],
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsx)(Picker, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                style: style === null || style === void 0 ? void 0 : style.inputWeb,
                enabled: !disabled,
                onValueChange: handleValueChange,
                selectedValue: selectedItem.value
            }, pickerProps), {
                children: allItems.map(function(item) {
                    return /* @__PURE__ */ (0,jsx_runtime.jsx)("option", {
                        value: item.value,
                        label: item.label,
                        children: item.label
                    }, item.key);
                })
            })),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(IconComponent, {
                Icon: Icon,
                style: style
            })
        ]
    });
}, IconComponent = function(param) {
    var Icon = param.Icon, style = param.style;
    return Icon ? /* @__PURE__ */ (0,jsx_runtime.jsx)(View/* default */.Z, {
        style: [
            {
                position: "absolute",
                right: 0
            },
            style === null || style === void 0 ? void 0 : style.iconContainer
        ],
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Icon, {})
    }) : null;
}, Select = /*#__PURE__*/ (0,react.forwardRef)(function(props, forwardedRef) {
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        ref: forwardedRef
    }));
}), Picker = /*#__PURE__*/ (0,react.forwardRef)(function(_param, forwardedRef) {
    var enabled = _param.enabled, onValueChange = _param.onValueChange, selectedValue = _param.selectedValue, children = _param.children, other = (0,_object_without_properties/* default */.Z)(_param, [
        "enabled",
        "onValueChange",
        "selectedValue",
        "children"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Select, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        disabled: enabled === !1 ? !0 : void 0,
        onChange: function(e) {
            var _target = e.target, selectedIndex = _target.selectedIndex, value = _target.value;
            onValueChange && onValueChange(value, selectedIndex);
        },
        ref: forwardedRef,
        value: selectedValue
    }, other), {
        children: children
    }));
});


;// CONCATENATED MODULE: ../bricks-next/dist/jsx/components/inputs/Dropdown/Dropdown.js

















var textInputTokens = Components/* tokens.textInput */.T.textInput, Dropdown = function(_param) {
    var analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, title = _param.title, supportText = _param.supportText, required = _param.required, externalErrorText = _param.errorText, externalInvalid = _param.invalid, disabled = _param.disabled, id = _param.id, name = _param.name, onFocus = _param.onFocus, externalOnBlur = _param.onBlur, onOpen = _param.onOpen, onClose = _param.onClose, onValueChange = _param.onValueChange, onOptionChange = _param.onOptionChange, options = _param.options, placeholderOption = _param.placeholderOption, prefilledValue = _param.prefilledValue, customErrorMessages = _param.customErrorMessages, onValidationChange = _param.onValidationChange, propsIn = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "trackImpression",
        "title",
        "supportText",
        "required",
        "errorText",
        "invalid",
        "disabled",
        "id",
        "name",
        "onFocus",
        "onBlur",
        "onOpen",
        "onClose",
        "onValueChange",
        "onOptionChange",
        "options",
        "placeholderOption",
        "prefilledValue",
        "customErrorMessages",
        "onValidationChange"
    ]);
    var ref, ref1;
    var _ref = (0,cjs.useProps)(propsIn), _size = _ref.size, size = _size === void 0 ? "medium" : _size, props = (0,_object_without_properties/* default */.Z)(_ref, [
        "size"
    ]), pickerId = (0,hooks/* useInputId */.U0)(id), items = (0,react.useMemo)(function() {
        return options.map(function(param) {
            var label = param.label, value2 = param.value;
            return {
                label: label,
                value: value2,
                key: value2
            };
        });
    }, [
        options
    ]), placeholder = (0,react.useMemo)(function() {
        return {
            label: (ref = placeholderOption === null || placeholderOption === void 0 ? void 0 : placeholderOption.label) !== null && ref !== void 0 ? ref : "Select an item",
            value: (ref1 = placeholderOption === null || placeholderOption === void 0 ? void 0 : placeholderOption.value) !== null && ref1 !== void 0 ? ref1 : "",
            key: "placeholder"
        };
    }, [
        placeholderOption === null || placeholderOption === void 0 ? void 0 : placeholderOption.label,
        placeholderOption === null || placeholderOption === void 0 ? void 0 : placeholderOption.value
    ]), ref2 = (0,react.useState)(prefilledValue !== null && prefilledValue !== void 0 ? prefilledValue : placeholder.value), value = ref2[0], setValue = ref2[1], ref3 = (0,react.useState)(), internalErrorText = ref3[0], setInternalErrorText = ref3[1], ref4 = (0,react.useState)("unknown"), internalValidationState = ref4[0], setInternalValidationState = ref4[1], validate = (0,react.useCallback)(function(value2) {
        var errorText2, validationState = "valid";
        var ref;
        return value2 === "" && required && (errorText2 = (ref = customErrorMessages === null || customErrorMessages === void 0 ? void 0 : customErrorMessages.fieldRequired) !== null && ref !== void 0 ? ref : "This field is required", validationState = "invalid"), setInternalErrorText(errorText2), setInternalValidationState(validationState), validationState;
    }, [
        required,
        customErrorMessages === null || customErrorMessages === void 0 ? void 0 : customErrorMessages.fieldRequired
    ]), handleValueChange = (0,react.useCallback)(function(val) {
        var value2 = typeof val == "string" ? val : "";
        setValue(value2);
        var option = options.find(function(opt) {
            return opt.value === value2;
        }) || placeholderOption || {
            label: placeholder.label,
            value: placeholder.value
        };
        onValueChange && onValueChange(value2), onOptionChange && onOptionChange(option);
        var validationState = validate(value2);
        onValidationChange && onValidationChange(validationState);
    }, [
        validate,
        onValueChange,
        onOptionChange,
        onValidationChange,
        options,
        placeholderOption,
        placeholder
    ]), onBlur = (0,react.useCallback)(function(e) {
        validate(value), externalOnBlur && externalOnBlur(e);
    }, [
        value,
        validate,
        externalOnBlur
    ]), errorText = externalErrorText !== null && externalErrorText !== void 0 ? externalErrorText : internalErrorText, invalid = !!errorText || externalInvalid || internalValidationState === "invalid", ref5 = (0,hooks/* useInputState */.U1)({
        errorText: errorText,
        invalid: invalid,
        disabled: disabled,
        onFocus: onFocus,
        onBlur: onBlur
    }), state = ref5.state, handleBlur = ref5.handleBlur, handleFocus = ref5.handleFocus, setFocused = ref5.setFocused, handleOpen = (0,react.useCallback)(function() {
        setFocused(!0), onOpen && onOpen();
    }, [
        setFocused,
        onOpen
    ]), handleClose = (0,react.useCallback)(function() {
        setFocused(!1), validate(value), onClose && onClose();
    }, [
        setFocused,
        validate,
        value,
        onClose
    ]), ref6 = (0,react.useMemo)(function() {
        return getStyles({
            size: size,
            state: state
        });
    }, [
        size,
        state
    ]), frameHeight = ref6.frameHeight, inputStyles = ref6.inputStyles, viewContainerStyles = ref6.viewContainerStyles, placeholderStyles = ref6.placeholderStyles, iconContainerStyles = ref6.iconContainerStyles, iconStyles = ref6.iconStyles;
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(TrackableContainer/* TrackableContainer */.z, {
        analyticsName: analyticsName,
        trackImpression: trackImpression,
        eventName: "inputViewEvent",
        gap: textInputTokens.padding.gap.textAndField[size],
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsx)(InputLabel/* InputLabel */.A, {
                size: size,
                title: title,
                supportText: supportText,
                id: pickerId,
                required: required,
                state: state
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(InputFrame/* InputFrame */.z, {
                size: size,
                state: state,
                height: frameHeight,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(PickerSelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    items: items,
                    disabled: disabled,
                    placeholder: placeholder,
                    value: value,
                    onValueChange: handleValueChange,
                    pickerProps: (0,_object_spread/* default */.Z)({
                        id: pickerId,
                        onFocus: handleFocus,
                        onBlur: handleBlur
                    }, cjs.isWeb ? {
                        "aria-invalid": state === "error",
                        "aria-required": required,
                        name: name
                    } : {}),
                    onOpen: handleOpen,
                    onClose: handleClose,
                    useNativeAndroidPickerStyle: !1,
                    fixAndroidTouchableBug: !0,
                    style: {
                        viewContainer: viewContainerStyles,
                        inputWeb: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, inputStyles, value === placeholder.value ? placeholderStyles : {}), {
                            outlineStyle: "none",
                            cursor: state === "inactive" ? "default" : "pointer",
                            appearance: "none",
                            textOverflow: "ellipsis"
                        }),
                        inputIOS: inputStyles,
                        chevronUp: {
                            display: "none"
                        },
                        chevronDown: {
                            display: "none"
                        },
                        inputAndroid: inputStyles,
                        headlessAndroidContainer: StyleSheet/* default.absoluteFill */.Z.absoluteFill,
                        iconContainer: iconContainerStyles,
                        placeholder: placeholderStyles
                    },
                    touchableWrapperProps: cjs.isAndroid ? {
                        style: viewContainerStyles
                    } : {},
                    Icon: function() {
                        return(// This toggles the chevron icon on ios/android. On web, there doesn't
                        // seem to be a good way to know if the picker is open because it's
                        // possible to focus the picker without opening it and `select`
                        // doesn't have an event corresponding to open/close.
                        !cjs.isWeb && state === "focused" ? /* @__PURE__ */ (0,jsx_runtime.jsx)(ChevronUp/* default */.Z, (0,_object_spread/* default */.Z)({}, iconStyles)) : /* @__PURE__ */ (0,jsx_runtime.jsx)(ChevronDown/* default */.Z, (0,_object_spread/* default */.Z)({}, iconStyles)));
                    }
                }))
            }),
            /* @__PURE__ */ (0,jsx_runtime.jsx)(InputError/* InputError */.p, {
                errorText: errorText
            })
        ]
    });
}, getStyles = function(param) {
    var size = param.size, state = param.state;
    var typopgraphyToken = textInputTokens.typography.valueText[size], colorToken = (0,utils/* isKeyOfObject */.E)(state, textInputTokens.color.content.valueText.state) ? textInputTokens.color.content.valueText.state[state] : textInputTokens.color.content.valueText.default, paddingVerticalToken = textInputTokens.padding.topBottom[size], paddingHorizontalToken = textInputTokens.padding.leftRight[size], borderWidthToken = textInputTokens.borderWidth.default, paddingVertical = (0,cjs.getTokenValue)(paddingVerticalToken, "space"), paddingHorizontal = (0,cjs.getTokenValue)(paddingHorizontalToken, "space"), borderWidth = (0,cjs.getTokenValue)(borderWidthToken, "space"), lineHeight = (0,fontTokens/* getTypographyValue */.Yp)(typopgraphyToken, "lineHeight"), fontScale = PixelRatio/* default.getFontScale */.Z.getFontScale(), frameHeight = lineHeight * fontScale + 2 * paddingVertical + 2 * borderWidth, viewContainerStyles = {
        position: "absolute",
        top: -borderWidth,
        bottom: -borderWidth,
        left: -borderWidth,
        right: -borderWidth,
        zIndex: 1
    }, iconContainerStyles = {
        top: 0,
        bottom: 0,
        right: paddingHorizontal + borderWidth,
        justifyContent: "center",
        zIndex: -1
    }, fontWeight = (0,fontTokens/* getTypographyValue */.Yp)(typopgraphyToken, "weight"), iconSize = size === "small" || size === "xsmall" ? 20 : 24, iconGap = (0,cjs.getTokenValue)(textInputTokens.padding.gap.textAndIcon.default, "space"), inputStyles = {
        fontFamily: (0,fontTokens/* getFontName */.Yw)(fontWeight),
        fontSize: (0,fontTokens/* getTypographyValue */.Yp)(typopgraphyToken, "size"),
        fontWeight: fontWeight,
        letterSpacing: (0,fontTokens/* getTypographyValue */.Yp)(typopgraphyToken, "letterSpacing"),
        color: (0,cjs.getTokenValue)(colorToken, "color"),
        borderWidth: borderWidth,
        borderColor: "transparent",
        backgroundColor: "transparent",
        height: frameHeight,
        paddingVertical: paddingVertical,
        paddingLeft: paddingHorizontal,
        paddingRight: paddingHorizontal + iconSize + iconGap
    }, placeholderStyles = {
        color: (0,cjs.getTokenValue)(textInputTokens.color.content.placeholderText.default, "color")
    };
    return {
        frameHeight: frameHeight,
        viewContainerStyles: viewContainerStyles,
        iconContainerStyles: iconContainerStyles,
        inputStyles: inputStyles,
        placeholderStyles: placeholderStyles,
        iconStyles: {
            size: iconSize,
            color: colorToken
        }
    };
};



/***/ }),

/***/ 86098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AddressInput; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../cinderblocks/es/helpers/globals.mjs
var globals = __webpack_require__(74411);
// EXTERNAL MODULE: ../observability/dist/chunks/chunk-VIS2X3AA.mjs + 1 modules
var chunk_VIS2X3AA = __webpack_require__(34654);
// EXTERNAL MODULE: ../../node_modules/.pnpm/js-cookie@2.1.4/node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(37462);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
;// CONCATENATED MODULE: ../cinderblocks/es/helpers/api.mjs
/* provided dependency */ var process = __webpack_require__(73656);







//#region src/helpers/api.ts
var DEPLOY_ENV = (0,globals/* getDeployEnv */.BS)();
var XSRF_COOKIE_KEY = DEPLOY_ENV !== "development" ? "XSRF-G-TOKEN" : "XSRF-TOKEN";
var DEFAULT_LOCALDEV_ATHENA_URL = "http://localhost:4000/api/graphql";
var getWindowEnv = function() {
    if (false) {}
    return window.ENV;
};
var getLocaldevAthenaUrl = function() {
    var windowEnv = getWindowEnv();
    return (windowEnv === null || windowEnv === void 0 ? void 0 : windowEnv.ODFE_ATHENA_URL) || (windowEnv === null || windowEnv === void 0 ? void 0 : windowEnv.REACT_APP_GRAPHQL_API_URL) || typeof process !== "undefined" && process.env.ODFE_ATHENA_URL || typeof process !== "undefined" && process.env.REACT_APP_GRAPHQL_API_URL || DEFAULT_LOCALDEV_ATHENA_URL;
};
var ATHENA_URL = {
    production: "https://graphql.apps.opendoor.com/api/graphql",
    development: "https://graphql.simplersell.com/api/graphql",
    localdev: getLocaldevAthenaUrl(),
    qa: "https://graphql.simplersell.com/api/graphql",
    staging: "https://graphql.simplersell.com/api/graphql",
    test: "https://graphql.simplersell.com/api/graphql"
}[DEPLOY_ENV];
/**
* A wrapper around `fetch` with optional retries.
* Retries up to `options.retries` times (defaults to `5` if not specified)
* with a delay of `options.retryDelay` (defaults to `500ms` if not specified)
*/ var fetchWithRetry = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(url, options) {
        var retries, retryDelay, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    retries = options.retries || 0;
                    retryDelay = options.retryDelay || 500;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    err = _state.sent();
                    if (retries < 1) throw err;
                    return [
                        4,
                        new Promise(function(r) {
                            return setTimeout(r, retryDelay);
                        })
                    ];
                case 4:
                    _state.sent();
                    return [
                        4,
                        fetchWithRetry(url, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                            retries: retries - 1
                        }))
                    ];
                case 5:
                    return [
                        2,
                        _state.sent()
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchWithRetry(url, options) {
        return _ref.apply(this, arguments);
    };
}();
var Sentry = chunk_VIS2X3AA/* globalObservability.getSentryClient */.w.getSentryClient();
function handleResponse(res) {
    var ref;
    if (res.ok) return res.json();
    (ref = Sentry.withScope) === null || ref === void 0 ? void 0 : ref.call(Sentry, function(scope) {
        var ref;
        scope.setExtras({
            resonse: res
        });
        (ref = Sentry.captureMessage) === null || ref === void 0 ? void 0 : ref.call(Sentry, "Non-200 response received in api call");
    });
}
function doBFFPost(apiUrl, jsonParams) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return fetchWithRetry(apiUrl, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        retries: 5,
        retryDelay: 500,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(jsonParams)
    }, options), {
        headers: (0,_object_spread/* default */.Z)({
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": js_cookie_default().get(XSRF_COOKIE_KEY) || ""
        }, options.headers)
    }));
}
function listUnits(addressUUID) {
    return doBFFPost(ATHENA_URL, {
        operationName: "ListUnits",
        query: "query ListUnits($addressUUID: String!, $limit: Float!) {\n        casa {\n          listUnits(input: { uuid: $addressUUID, limit: $limit }) {\n            addresses{\n              uuid\n              result\n            }\n          }\n        }\n      }",
        variables: {
            addressUUID: addressUUID,
            limit: 10
        }
    }, {
        headers: {
            "apollographql-client-name": "cinderblocks"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function standardizeAddress(address) {
    return doBFFPost(ATHENA_URL, {
        operationName: "StandardizeAddress",
        query: "query StandardizeAddress($address: OdProtosCasaServices_CasaRequest_FindByFieldsInput!) {\n      casa {\n        findByFields(input: $address) {\n          address {\n            uuid\n            street\n            city\n            state\n            unitNumber\n            unitType\n            postalCode\n            latitude\n            longitude\n            result\n          }\n        }\n      }\n    }",
        variables: {
            address: {
                city: address.city,
                postalCode: address.postal_code,
                state: address.state,
                street: address.street1,
                unitNumber: address.unit
            }
        }
    }, {
        headers: {
            "apollographql-client-name": "cinderblocks"
        }
    }).then(handleResponse).catch(function(e) {
        var ref;
        return (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
    });
}
function createMortgageLead(input) {
    return doBFFPost(ATHENA_URL, {
        operationName: "MortgageLead",
        query: "\n    mutation MortgageLead($input: OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_CreateMortgageLeadInput!) {\n      customerFinancingService {\n        createMortgageLead(input: $input) {\n          mortgageLead {\n            mortgageLeadId\n            customerUuid\n          }\n        }\n      }\n    }\n  ",
        variables: {
            input: {
                customerUuid: input.customerUuid,
                channel: "CUSTOMER_EXPERIENCE",
                addressToken: input === null || input === void 0 ? void 0 : input.addressToken,
                propertyType: input.propertyType,
                targetMoveDate: input.targetMoveDate,
                targetPrice: input.targetPrice,
                targetDownPayment: input.targetDownPayment,
                targetLocation: input.targetLocation,
                employmentStatus: input.employmentStatus,
                householdIncomeMin: input.householdIncomeMin,
                householdIncomeMax: input.householdIncomeMax,
                firstName: input.firstName,
                lastName: input.lastName,
                phone: input.phone,
                email: input.email,
                currentAddress: input.currentAddress
            }
        }
    }, {
        headers: {
            "apollographql-client-name": "cinderblocks"
        }
    }).then(function() {
        var _ref = _async_to_generator(function(response) {
            var errorText, result;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!!response.ok) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            response.text()
                        ];
                    case 1:
                        errorText = _state.sent();
                        throw new Error("GraphQL mutation failed: ".concat(errorText));
                    case 2:
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        result = _state.sent();
                        if (result.errors) throw new Error("GraphQL errors: ".concat(JSON.stringify(result.errors)));
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function(response) {
            return _ref.apply(this, arguments);
        };
    }()).catch(function(e) {
        var ref;
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, e);
        throw e;
    });
}
//#endregion
 //# sourceMappingURL=api.mjs.map

;// CONCATENATED MODULE: ../cinderblocks/es/helpers/addressValidation.mjs




//#region src/helpers/addressValidation.ts
var UNIVERSAL_NIL_ADDRESS = "6aae647b-d603-5533-8464-c42c658b101a";
var ADDRESS_INVALID_RESULT = [
    "ADDRESS_NIL",
    "ADDRESS_UNKNOWN",
    "ADDRESS_MISSING_PREMISE",
    "ADDRESS_INVALID_PREMISE",
    "ADDRESS_NOT_SUPPORTED",
    "ADDRESS_NOT_REAL",
    "ADDRESS_INVALID",
    "ADDRESS_INVALID_STREET",
    "ADDRESS_INVALID_SUB_PREMISE",
    "ADDRESS_MISSING_BOX_NUMBER",
    "ADDRESS_INVALID_BOX_NUMBER",
    "ADDRESS_EXTRANEOUS_INPUT"
];
var doesAddressHaveMultipleUnits = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(addressUuid) {
        var ref, ref1, ref2, ref3;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        listUnits(addressUuid)
                    ];
                case 1:
                    return [
                        2,
                        (((ref = _state.sent()) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.casa) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.listUnits) === null || ref3 === void 0 ? void 0 : ref3.addresses) || []).some(function(address) {
                            var ref;
                            return address.uuid !== addressUuid && !((ref = address.result) === null || ref === void 0 ? void 0 : ref.some(function(casaResult) {
                                return ADDRESS_INVALID_RESULT.includes(casaResult);
                            }));
                        })
                    ];
            }
        });
    });
    return function doesAddressHaveMultipleUnits(addressUuid) {
        return _ref.apply(this, arguments);
    };
}();
var validateAddress = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(address) {
        var ref, moreResult, casaAddress, ref1, ref2, ref3, ref4, ref5, standardizeAddressResponse, addressResult, _tmp, combinedResults, needsManualEntry, needsUnitSelection;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    moreResult = [];
                    casaAddress = address;
                    if (!(address.source === "google")) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        standardizeAddress(address)
                    ];
                case 1:
                    standardizeAddressResponse = _state.sent();
                    if (!standardizeAddressResponse || !standardizeAddressResponse.data || standardizeAddressResponse.errors || ((ref2 = (ref1 = standardizeAddressResponse.data) === null || ref1 === void 0 ? void 0 : ref1.casa.findByFields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.address) === null || ref3 === void 0 ? void 0 : ref3.uuid) === "6aae647b-d603-5533-8464-c42c658b101a") {
                        moreResult = [
                            "ADDRESS_UNKNOWN"
                        ];
                        return [
                            2,
                            {
                                address: address,
                                results: moreResult,
                                needsManualEntry: true,
                                needsUnitSelection: false
                            }
                        ];
                    }
                    addressResult = (ref5 = (ref4 = standardizeAddressResponse.data) === null || ref4 === void 0 ? void 0 : ref4.casa.findByFields) === null || ref5 === void 0 ? void 0 : ref5.address;
                    casaAddress = {
                        id: addressResult.uuid,
                        street1: addressResult.street,
                        city: addressResult.city,
                        state: addressResult.state,
                        postal_code: addressResult.postalCode,
                        unit: addressResult.unitNumber,
                        result: addressResult.result,
                        latitude: address.latitude,
                        longitude: address.longitude,
                        source: "casa"
                    };
                    _state.label = 2;
                case 2:
                    if (!(!(casaAddress === null || casaAddress === void 0 ? void 0 : (ref = casaAddress.result) === null || ref === void 0 ? void 0 : ref.includes("ADDRESS_MISSING_SUB_PREMISE")) && (casaAddress === null || casaAddress === void 0 ? void 0 : casaAddress.unit) === "")) return [
                        3,
                        5
                    ];
                    _tmp = casaAddress.id;
                    if (!_tmp) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        doesAddressHaveMultipleUnits(casaAddress.id)
                    ];
                case 3:
                    _tmp = _state.sent();
                    _state.label = 4;
                case 4:
                    if (_tmp) moreResult = [
                        "ADDRESS_MISSING_SUB_PREMISE"
                    ];
                    _state.label = 5;
                case 5:
                    combinedResults = (0,_to_consumable_array/* default */.Z)((casaAddress === null || casaAddress === void 0 ? void 0 : casaAddress.result) || []).concat((0,_to_consumable_array/* default */.Z)(moreResult));
                    needsManualEntry = ADDRESS_INVALID_RESULT.some(function(error) {
                        return combinedResults.includes(error);
                    });
                    needsUnitSelection = combinedResults.includes("ADDRESS_MISSING_SUB_PREMISE");
                    return [
                        2,
                        {
                            address: casaAddress,
                            results: combinedResults,
                            needsManualEntry: needsManualEntry,
                            needsUnitSelection: needsUnitSelection
                        }
                    ];
            }
        });
    });
    return function validateAddress(address) {
        return _ref.apply(this, arguments);
    };
}();
//#endregion
 //# sourceMappingURL=addressValidation.mjs.map

// EXTERNAL MODULE: ../cinderblocks/es/helpers/googleMaps.mjs
var googleMaps = __webpack_require__(70573);
// EXTERNAL MODULE: ../cinderblocks/es/core/AutocompleteInput/AutocompleteInput.mjs
var AutocompleteInput = __webpack_require__(44293);
// EXTERNAL MODULE: ../cinderblocks/es/core/AutocompleteInput/index.mjs
var core_AutocompleteInput = __webpack_require__(35810);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(349);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(5108);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25313);
// EXTERNAL MODULE: ../bricks-next/dist/jsx/__generated__/icons/Search.js
var Search = __webpack_require__(49377);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(77837);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
;// CONCATENATED MODULE: ../cinderblocks/es/core/AddressInput/AddressInput.mjs










//#region src/core/AddressInput/AddressInput.tsx
var DEBOUNCE_INVOKE_WAIT_MS = 100;
/**
* @param actionButton overrides `icon` in the suffix position when provided
*/ var AddressInput = function(param) {
    var id = param.id, placeholder = param.placeholder, disabled = param.disabled, hideLabel = param.hideLabel, label = param.label, value = param.value, onChange = param.onChange, defaultValue = param.defaultValue, _fetchOnExternalValue = param.fetchOnExternalValue, fetchOnExternalValue = _fetchOnExternalValue === void 0 ? false : _fetchOnExternalValue, onAddressSelect = param.onAddressSelect, onAddressValidated = param.onAddressValidated, tmp = param.validateAddress, validateAddress$1 = tmp === void 0 ? false : tmp, onError = param.onError, onPredictionsChange = param.onPredictionsChange, onSearchTermChange = param.onSearchTermChange, onFocus = param.onFocus, onBlur = param.onBlur, customAction = param.customAction, listBoxId = param.listBoxId, listBoxAriaLabel = param.listBoxAriaLabel, icon = param.icon, actionButton = param.actionButton, size = param.size, supportText = param.supportText, errorText = param.errorText, invalid = param.invalid, required = param.required;
    var ref = (0,react.useState)([]), predictions = ref[0], setPredictions = ref[1];
    var ref1 = (0,react.useState)(null), usedPrediction = ref1[0], setUsedPrediction = ref1[1];
    var ref2 = (0,react.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : ""), internalSearchTerm = ref2[0], setInternalSearchTerm = ref2[1];
    var ref3 = (0,react.useState)(false), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react.useState)(function() {
        return (0,googleMaps/* generateGoogleMapsSessionToken */.h_)();
    }), sessionToken = ref4[0];
    var inputRef = (0,react.useRef)(null);
    var didMountRef = (0,react.useRef)(false);
    var isControlled = value !== void 0;
    var searchTerm = isControlled ? value : internalSearchTerm;
    var updateSearchTerm = function(newValue) {
        if (!isControlled) setInternalSearchTerm(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
    };
    (0,react.useEffect)(function() {
        onPredictionsChange === null || onPredictionsChange === void 0 ? void 0 : onPredictionsChange(predictions);
    }, [
        predictions,
        onPredictionsChange
    ]);
    (0,react.useEffect)(function() {
        if (!isControlled) onSearchTermChange === null || onSearchTermChange === void 0 ? void 0 : onSearchTermChange(searchTerm);
    }, [
        isControlled,
        searchTerm,
        onSearchTermChange
    ]);
    var clearPredictions = function() {
        setUsedPrediction(null);
        setPredictions([]);
    };
    var fetchAutocompleteOptions = (0,react.useMemo)(function() {
        return debounce_default()(function() {
            var _ref = (0,src_async_to_generator/* default */.Z)(function(input) {
                var data, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!input) {
                                clearPredictions();
                                return [
                                    2
                                ];
                            }
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                fetch((0,googleMaps/* buildAutocompleteUrl */.Iz)(input, sessionToken))
                            ];
                        case 2:
                            return [
                                4,
                                _state.sent().json()
                            ];
                        case 3:
                            data = _state.sent();
                            data.predictions.forEach(function(result) {
                                result.description = result.description.replace(", USA", "");
                                result.id = result.place_id || result.addressToken || result.description;
                                result.ariaLabel = result.description;
                            });
                            setPredictions(data.predictions.filter(function(result) {
                                result.source = data.source;
                                if (data.source === "google") {
                                    var _terms;
                                    var terms = (_terms = result.terms) !== null && _terms !== void 0 ? _terms : [];
                                    var _types;
                                    var allowedTypes = ((_types = result.types) !== null && _types !== void 0 ? _types : []).filter(function(type) {
                                        return googleMaps/* ALLOWED_TYPES.includes */.MF.includes(type);
                                    });
                                    return terms.length >= 5 && allowedTypes.length > 0 || terms.length === 4 && terms[0].value.match(/^\d+\S*\s\S+\s/) !== null;
                                }
                                return true;
                            }));
                            return [
                                3,
                                5
                            ];
                        case 4:
                            error = _state.sent();
                            clearPredictions();
                            onError === null || onError === void 0 ? void 0 : onError(error);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(input) {
                return _ref.apply(this, arguments);
            };
        }(), DEBOUNCE_INVOKE_WAIT_MS);
    }, [
        sessionToken,
        onError
    ]);
    (0,react.useEffect)(function() {
        if (!fetchOnExternalValue) return;
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (searchTerm === "") clearPredictions();
        else fetchAutocompleteOptions(searchTerm);
    }, [
        fetchOnExternalValue,
        searchTerm,
        fetchAutocompleteOptions
    ]);
    var handleInputChange = function(e) {
        var newValue = e.target.value;
        updateSearchTerm(newValue);
        fetchAutocompleteOptions(newValue);
        if (newValue === "") clearPredictions();
    };
    var handlePredictionSelect = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(prediction) {
            var ref, url, address, validationError, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
                        setUsedPrediction(prediction);
                        updateSearchTerm(prediction.description);
                        setPredictions([]);
                        setIsLoading(true);
                        url = prediction.source === "google" ? (0,googleMaps/* buildPlacesUrl */.dl)({
                            source: "google",
                            placeId: prediction.place_id,
                            sessionToken: sessionToken
                        }) : (0,googleMaps/* buildPlacesUrl */.dl)({
                            source: "casa",
                            addressToken: prediction.addressToken,
                            sessionToken: sessionToken
                        });
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            9,
                            10
                        ]);
                        return [
                            4,
                            fetch(url)
                        ];
                    case 2:
                        return [
                            4,
                            _state.sent().json()
                        ];
                    case 3:
                        address = _state.sent();
                        if (!(validateAddress$1 && onAddressValidated)) return [
                            3,
                            7
                        ];
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            validateAddress(address)
                        ];
                    case 5:
                        onAddressValidated.apply(void 0, [
                            _state.sent()
                        ]);
                        return [
                            3,
                            7
                        ];
                    case 6:
                        validationError = _state.sent();
                        onError === null || onError === void 0 ? void 0 : onError(validationError);
                        return [
                            3,
                            7
                        ];
                    case 7:
                        onAddressSelect(address);
                        return [
                            3,
                            10
                        ];
                    case 8:
                        error = _state.sent();
                        onError === null || onError === void 0 ? void 0 : onError(error);
                        return [
                            3,
                            10
                        ];
                    case 9:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 10:
                        return [
                            2
                        ];
                }
            });
        });
        return function handlePredictionSelect(prediction) {
            return _ref.apply(this, arguments);
        };
    }();
    var renderItem = function(prediction) {
        return /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
            typography: size ? ({
                xsmall: "$bodyMedium",
                small: "$bodyMedium",
                medium: "$bodyLarge",
                large: "$bodyXlarge"
            })[size] : "$bodyXlarge",
            tag: "span",
            textAlign: "left",
            $smallerThanMD: {
                typography: "$bodyMedium"
            },
            px: 10,
            py: 2,
            children: prediction.description
        });
    };
    var useSuffix = icon !== null && icon !== void 0 ? icon : isLoading ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        position: "relative",
        px: "$4",
        display: "block",
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Button/* ButtonLoadingAnimation */.V, {
            variant: "secondary",
            size: "xsmall"
        })
    }) : /* @__PURE__ */ (0,jsx_runtime.jsx)(Search/* default */.Z, {});
    if (actionButton) {
        var onPress = function() {
            if (predictions.length && predictions[0]) handlePredictionSelect(predictions[0]);
            else if (usedPrediction && searchTerm === usedPrediction.description) handlePredictionSelect(usedPrediction);
        };
        useSuffix = actionButton(onPress, isLoading);
    }
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(AutocompleteInput/* default */.Z, {
        id: id,
        label: label,
        hideLabel: hideLabel,
        placeholder: placeholder,
        disabled: disabled,
        items: predictions,
        searchTerm: searchTerm,
        onSearchChange: handleInputChange,
        onItemSelect: handlePredictionSelect,
        renderItem: renderItem,
        suffix: useSuffix,
        customAction: customAction,
        listBoxId: listBoxId,
        onEscape: function() {
            return clearPredictions();
        },
        onFocus: onFocus,
        onBlur: onBlur,
        listBoxAriaLabel: listBoxAriaLabel,
        size: size,
        supportText: supportText,
        errorText: errorText,
        invalid: invalid,
        required: required,
        inputRef: inputRef
    });
};
//#endregion
 //# sourceMappingURL=AddressInput.mjs.map

;// CONCATENATED MODULE: ../cinderblocks/es/core/AddressInput/index.mjs




/***/ }),

/***/ 44293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AutocompleteInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93089);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5108);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48923);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53033);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31549);





//#region src/core/AutocompleteInput/AutocompleteInput.tsx
var ListBoxElement = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ListBoxElement(props, forwardedRef) {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        ref: forwardedRef
    }));
});
var BricksNextListBox = function(param) {
    var children = param.children, listBoxId = param.listBoxId, _ariaLabel = param.ariaLabel, ariaLabel = _ariaLabel === void 0 ? "suggestions" : _ariaLabel, _size = param.size, size = _size === void 0 ? "medium" : _size;
    var borderRadius = {
        small: "$7x",
        medium: "$9x",
        large: "$12x"
    }[size] || "$9x";
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
        borderBottomLeftRadius: borderRadius,
        borderBottomRightRadius: borderRadius,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        maxHeight: 450,
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        marginTop: -1.5,
        borderLeftWidth: 1.5,
        borderRightWidth: 1.5,
        borderBottomWidth: 1.5,
        borderTopWidth: 0,
        borderStyle: "solid",
        borderColor: "$borderAccentBrand",
        backgroundColor: "$backgroundPrimary",
        overflow: "hidden",
        zIndex: 1e3,
        children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListBoxElement, {
            role: "listbox",
            "aria-label": ariaLabel,
            id: listBoxId,
            style: {
                padding: 0,
                margin: 0,
                listStyleType: "none"
            },
            children: children
        })
    });
};
var AutocompleteInput = function(param) {
    var id = param.id, label = param.label, hideLabel = param.hideLabel, placeholder = param.placeholder, disabled = param.disabled, items = param.items, searchTerm = param.searchTerm, onSearchChange = param.onSearchChange, onItemSelect = param.onItemSelect, renderItem = param.renderItem, suffix = param.suffix, customAction = param.customAction, _listBoxId = param.listBoxId, listBoxId = _listBoxId === void 0 ? "autocomplete-listbox" : _listBoxId, listBoxAriaLabel = param.listBoxAriaLabel, onEscape = param.onEscape, onFocus = param.onFocus, onBlur = param.onBlur, _size = param.size, size = _size === void 0 ? "medium" : _size, supportText = param.supportText, errorText = param.errorText, invalid = param.invalid, required = param.required, externalInputRef = param.inputRef;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(void 0), selectedIndex = ref[0], setSelectedIndex = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isFocused = ref1[0], setIsFocused = ref1[1];
    var internalInputRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var inputRef = externalInputRef || internalInputRef;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (selectedIndex !== void 0 && selectedIndex >= items.length) setSelectedIndex(void 0);
    }, [
        items,
        selectedIndex
    ]);
    var handleItemSelect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(item) {
        return function() {
            var ref;
            onItemSelect(item);
            (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
        };
    }, [
        onItemSelect,
        inputRef
    ]);
    var onKeyDown = function(e) {
        if (e.key === "ArrowDown") {
            e.preventDefault();
            if (items.length > 0) setSelectedIndex(selectedIndex === void 0 || selectedIndex === items.length - 1 ? 0 : selectedIndex + 1);
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            if (items.length > 0) setSelectedIndex(selectedIndex === void 0 || selectedIndex === 0 ? items.length - 1 : selectedIndex - 1);
        } else if (e.key === "Enter") {
            e.preventDefault();
            if (selectedIndex !== void 0 && items[selectedIndex]) {
                var ref;
                onItemSelect(items[selectedIndex]);
                (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.blur();
            }
        } else if (e.key === "Escape") {
            setSelectedIndex(void 0);
            onEscape === null || onEscape === void 0 ? void 0 : onEscape();
        } else setSelectedIndex(void 0);
    };
    var handleContainerBlur = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (!e.currentTarget.contains(e.relatedTarget)) {
            setIsFocused(false);
            onBlur === null || onBlur === void 0 ? void 0 : onBlur();
        }
    }, [
        onBlur
    ]);
    var handleContainerFocus = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setIsFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    }, [
        onFocus
    ]);
    var handleMouseDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        e.preventDefault();
    }, []);
    var showDropdown = searchTerm !== "" && isFocused;
    {
        var textInputProps = {
            id: id,
            placeholder: placeholder,
            disabled: disabled,
            value: searchTerm,
            onChangeText: function(text) {
                onSearchChange({
                    target: {
                        value: text
                    }
                });
            },
            onKeyPress: onKeyDown,
            size: size,
            supportText: supportText,
            errorText: errorText,
            invalid: invalid,
            required: required,
            autoComplete: "off",
            role: "combobox",
            "aria-autocomplete": "list",
            "aria-expanded": showDropdown ? "true" : "false",
            "aria-controls": listBoxId
        };
        if (!hideLabel && label) textInputProps.title = label;
        else if (label) textInputProps.ariaLabel = label;
        else textInputProps.ariaLabel = "Search input";
        if (showDropdown && (items.length > 0 || customAction)) textInputProps.frameProps = {
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomWidth: 0
        };
        return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
            onFocus: handleContainerFocus,
            onBlur: handleContainerBlur,
            children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                position: "relative",
                children: [
                    /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .TextInput */ .o, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, textInputProps), {
                        ref: inputRef,
                        children: suffix
                    })),
                    showDropdown && (items.length > 0 || customAction) && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(BricksNextListBox, {
                        listBoxId: listBoxId,
                        ariaLabel: listBoxAriaLabel,
                        size: size,
                        children: [
                            items.map(function(item, index) {
                                var isSelected = selectedIndex === index;
                                return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                                    tag: "li",
                                    id: "autocomplete-options",
                                    role: "option",
                                    "aria-selected": isSelected || void 0,
                                    overflow: "hidden",
                                    children: /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .PressableBox */ .K, {
                                        zIndex: 2,
                                        justifyContent: "flex-start",
                                        onMouseDown: handleMouseDown,
                                        analyticsName: "",
                                        "aria-label": item.ariaLabel,
                                        animation: "accelerateDecelerateFastest",
                                        height: "100%",
                                        width: "100%",
                                        backgroundColor: isSelected ? "$backgroundStateHoverPrimary" : "$backgroundPrimary",
                                        hoverStyle: {
                                            backgroundColor: "$backgroundStateHoverPrimary"
                                        },
                                        onPress: handleItemSelect(item),
                                        pressStyle: {
                                            scale: .98
                                        },
                                        padding: 10,
                                        children: renderItem(item, isSelected)
                                    })
                                }, item.id);
                            }),
                            customAction
                        ]
                    })
                ]
            })
        });
    }
    return null;
};
//#endregion
 //# sourceMappingURL=AutocompleteInput.mjs.map


/***/ }),

/***/ 35810:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _AutocompleteInput_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44293);




/***/ }),

/***/ 74411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BS": function() { return /* binding */ getDeployEnv; },
/* harmony export */   "aD": function() { return /* binding */ isDevelopmentEnv; },
/* harmony export */   "n5": function() { return /* binding */ isProductionEnv; }
/* harmony export */ });
/* unused harmony exports GOOGLE_CLIENT_ID, GOOGLE_MAPS_KEY, SUPPORTED_LOCALES */
/* harmony import */ var _opendoor_shared_fe_commonGlobals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7004);
/* harmony import */ var _opendoor_shared_fe_railsEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36544);
/* provided dependency */ var process = __webpack_require__(73656);


//#region src/helpers/globals.ts
var secrets = _opendoor_shared_fe_commonGlobals__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z[(0,_opendoor_shared_fe_railsEnv__WEBPACK_IMPORTED_MODULE_1__/* .getRailsEnv */ .YE)()];
var GOOGLE_CLIENT_ID = secrets.googleClientID;
var GOOGLE_MAPS_KEY = secrets.googleMaps;
var SUPPORTED_LOCALES = (/* unused pure expression or super */ null && ([
    "en-US",
    "es"
]));
/**
* Gets the current environment in a framework-agnostic way.
* Works with Next.js (Cosmos), Remix (Cake), and browser contexts.
*
* Priority order:
* 1. window.ENV?.DEPLOY_ENV (Remix client-side)
* 2. process.env.NEXT_PUBLIC_DEPLOY_ENV (Next.js client & server)
* 3. process.env.DEPLOY_ENV (Remix server-side)
* 4. getRailsEnv() (Fallback to hostname detection)
*/ var getDeployEnv = function() {
    var ref, ref1, ref2;
    if ( true && ((ref = window.ENV) === null || ref === void 0 ? void 0 : ref.DEPLOY_ENV)) return window.ENV.DEPLOY_ENV;
    if (typeof process !== "undefined" && ((ref1 = process.env) === null || ref1 === void 0 ? void 0 : "production")) return "production";
    if (typeof process !== "undefined" && ((ref2 = process.env) === null || ref2 === void 0 ? void 0 : ref2.DEPLOY_ENV)) return process.env.DEPLOY_ENV;
    return (0,_opendoor_shared_fe_railsEnv__WEBPACK_IMPORTED_MODULE_1__/* .getRailsEnv */ .YE)();
};
/**
* Checks if the current deploy environment is production.
*/ var isProductionEnv = function() {
    return getDeployEnv() === "production";
};
/**
* Checks if the current deploy environment is development.
*/ var isDevelopmentEnv = function() {
    return getDeployEnv() === "development";
};
//#endregion
 //# sourceMappingURL=globals.mjs.map


/***/ }),

/***/ 70573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iz": function() { return /* binding */ buildAutocompleteUrl; },
/* harmony export */   "MF": function() { return /* binding */ ALLOWED_TYPES; },
/* harmony export */   "dl": function() { return /* binding */ buildPlacesUrl; },
/* harmony export */   "h_": function() { return /* binding */ generateGoogleMapsSessionToken; },
/* harmony export */   "wC": function() { return /* binding */ buildCityAutocompleteUrl; }
/* harmony export */ });
/* harmony import */ var _globals_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74411);

//#region src/helpers/googleMaps.ts
var getAddressInputUrl = function() {
    if ((0,_globals_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isProductionEnv */ .n5)() || (0,_globals_mjs__WEBPACK_IMPORTED_MODULE_0__/* .getDeployEnv */ .BS)() === "localdev") return "/_address-input";
    return "https://demo.simplersell.com/_address-input";
};
var ADDRESS_INPUT_URL = getAddressInputUrl();
var ALLOWED_TYPES = [
    "street_address",
    "premise",
    "subpremise",
    "route"
];
var generateGoogleMapsSessionToken = function() {
    return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
};
var buildAutocompleteUrl = function(query, sessionToken) {
    return "".concat(ADDRESS_INPUT_URL, "/autocomplete?sessionToken=").concat(sessionToken, "&query=").concat(query);
};
var buildCityAutocompleteUrl = function(query, sessionToken) {
    return "".concat(ADDRESS_INPUT_URL, "/autocomplete?sessionToken=").concat(sessionToken, "&query=").concat(encodeURIComponent(query), "&types=(regions)");
};
var buildPlacesUrl = function(param) {
    var source = param.source, placeId = param.placeId, addressToken = param.addressToken, sessionToken = param.sessionToken;
    var baseUrl = "".concat(ADDRESS_INPUT_URL, "/place");
    if (source === "casa") return baseUrl + "?addressToken=".concat(addressToken);
    return baseUrl + "?sessionToken=".concat(sessionToken, "&placeId=").concat(placeId);
};
//#endregion
 //# sourceMappingURL=googleMaps.mjs.map


/***/ }),

/***/ 36544:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YE": function() { return /* binding */ getRailsEnv; }
/* harmony export */ });
/* unused harmony exports assertRailEnvOrThrow, isRailsEnv */
//#region src/railsEnv.ts
var envs = (/* unused pure expression or super */ null && ([
	"production",
	"staging",
	"qa",
	"development",
	"localdev",
	"test"
]));
function isRailsEnv(env) {
	return envs.indexOf(env) !== -1;
}
function assertRailEnvOrThrow(env) {
	if (isRailsEnv(env)) return env;
	throw new Error(`${env} is not a valid RailsEnv`);
}
var getRailsEnv = () => {
	if (typeof window === "undefined" || typeof document === "undefined") return "development";
	const hostname = window?.location?.hostname;
	if (hostname === void 0) return "development";
	const port = window?.location?.port;
	const locationHasPort = port && port !== "";
	const onLocalhost = hostname === "localhost";
	const onNgrok = hostname.includes(".ngrok.io");
	const onXipIO = hostname.includes(".xip.io");
	const inAndroidEmulator = hostname.includes("10.0.2.2");
	if (onLocalhost && locationHasPort || onNgrok || onXipIO || inAndroidEmulator) return "development";
	if (hostname === "127.0.0.1" || onLocalhost) return "test";
	const onStagingManagedDomain = hostname.includes("-staging.managed.services.opendoor.com") || hostname.includes("-staging.ops.opendoor.com") || hostname.includes("-staging.opendoor.com");
	const onSimplersell = hostname.includes(".simplersell.com");
	const onODMortgage = hostname.includes(".odmortgage.com");
	const inStaging = onStagingManagedDomain || onSimplersell || onODMortgage;
	const inProduction = hostname.includes(".opendoor.com") && !hostname.includes("-staging");
	const inProdOrStaging = inStaging || inProduction;
	const onQADomain = hostname.includes("-qa-");
	const hasQACookie = document?.cookie?.includes("qa=") && document?.cookie?.includes("qa_env=");
	if (onQADomain || inProdOrStaging && hasQACookie) return "qa";
	else if (inStaging) return "staging";
	else if (inProduction) return "production";
	return "development";
};
//#endregion


//# sourceMappingURL=railsEnv.mjs.map

/***/ })

}]);